import { createHash } from 'rusha';
import type { QuickSearchResponseData } from '../../common/types.tsx';

export const getQueryHash = (str: string): string => createHash().update(str).digest('hex');

export const getWordCount = (str: string) => (str.length > 0 ? str.split(/\s+/).length : 0);

export const transformResultsForAnalytics = (
	data: QuickSearchResponseData | undefined,
	isRecentResult: boolean,
) => {
	const results = data?.scopes?.map((scope) => ({
		sectionId: scope.id,
		results: scope.results.map((result) => ({
			containerId:
				result?.attributes && 'containerId' in result?.attributes
					? result?.attributes?.containerId || 'UNAVAILABLE'
					: 'UNAVAILABLE',
			isRecentResult,
			resultContentId: result.id,
			resultType: scope.id,
		})),
	}));

	const resultCount = data?.scopes?.reduce((acc, scope) => acc + scope.size, 0);

	return {
		results,
		sectionCount: data?.scopes?.length || 0,
		resultCount,
		noResultsFetched: !results?.find((scope) => scope.results.length > 0),
	};
};
